<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-10">
    <div
      class="sm:border-t-opacity-10 sm:border-t-[2.5px] sm:border-t-beige sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]"></div>
    <section class="mx-auto flex max-w-[1440px] flex-col justify-start min-h-[800px]">
      <div
        class="ml-[31px] pb-[35px] pt-[17px] font-['Roboto'] text-xl font-medium text-cafe sm:ml-[116px] sm:pb-[37px] sm:pt-[41px] sm:text-2xl sm:font-semibold">
        {{ 'labels.services' | transloco }}
      </div>
      <div class="ml-[31px] flex flex-row flex-wrap gap-x-[43px] gap-y-[30px] sm:ml-[116px]">
        <ln-services-card
          [imagePath]="imagePathServicesManagement"
          [name]="'labels.propertyManagement' | transloco"
          [question]="'labels.propertyManagementQuestion' | transloco"
          [answer]="'labels.propertyManagementAnswer' | transloco"
          [serviceType]="'propertyManagement'"
        ></ln-services-card>
        <ln-services-card
          [imagePath]="imagePathServicesDesign"
          [name]="'labels.interiorDesign' | transloco"
          [question]="'labels.interiorDesignQuestion' | transloco"
          [answer]="'labels.interiorDesignAnswer' | transloco"
          [serviceType]="'interiorDesign'"
        ></ln-services-card>
      </div>
    </section>
    <div class="mx-auto max-w-[1440px] px-[36px] sm:px-[120px] pt-[40px]">
      <div class="flex items-center border-b-[2px] border-b-verde opacity-40"></div>
    </div>
  </section>
</ln-ln-pages-armor>
